import { useMemo } from "react";

import { useLocalStorage } from "usehooks-ts";

import { createFNVHashSync } from "../../authentication/utils";

export type RecentSearchesState = {
  recentSearches: string[];
};

export const DEFAULT_RECENT_SEARCHES_STATE: RecentSearchesState = {
  recentSearches: [],
};

export const getRecentSearchesStorageKey = (userId: string): string => {
  const hashedId = createFNVHashSync(userId);
  return `recent_transaction_searches_${hashedId}`;
};

export const useRecentSearchesStorage = (userId: string) => {
  const storageKey = useMemo(
    () => getRecentSearchesStorageKey(userId),
    [userId]
  );

  const [state, setState, removeValue] = useLocalStorage<RecentSearchesState>(
    storageKey,
    DEFAULT_RECENT_SEARCHES_STATE
  );

  return [state, setState, removeValue] as const;
};
